import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-loading">
        <img src={LOGO_URL} alt="BEAUTWELLZ" className="h-14 w-14 rounded-xl object-cover animate-pulse" />
        <p className="text-sm text-muted-foreground">Loading your workspace…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}
